export function ActiveSessionSection() {
  return (
    <section className="section-y section-x bg-surface-container-lowest">
      <div className="max-w-7xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1 bg-primary-container rounded-full mb-6 sm:mb-8">
          <span className="w-2 h-2 rounded-full bg-tertiary animate-pulse" />
          <span className="text-primary text-[10px] sm:text-xs font-bold tracking-widest uppercase">
            Live Tracking
          </span>
        </div>

        <h2 className="font-headline font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-4 sm:mb-6">
          Track Without Breaking Focus
        </h2>
        <p className="text-on-surface-variant max-w-2xl mx-auto text-base sm:text-lg mb-10 sm:mb-12 px-2">
          Keep the workout moving with clear targets, fast set logging, rest cues, and progress
          context where you need it.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
          <div className="md:col-span-2 bg-surface-container-high p-6 sm:p-8 lg:p-10 rounded-2xl sm:rounded-3xl text-left flex flex-col justify-between">
            <div>
              <h3 className="text-2xl sm:text-3xl font-headline font-bold mb-3 sm:mb-4">
                Fast Set Logging
              </h3>
              <p className="text-on-surface-variant text-sm sm:text-base">
                See what is next, log what you did, and keep your pace without digging through menus
                between sets.
              </p>
            </div>
            <div className="mt-6 sm:mt-8 flex gap-4">
              <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full border-4 border-primary/20 flex items-center justify-center">
                <span className="text-primary font-bold text-lg sm:text-xl">85%</span>
              </div>
              <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full border-4 border-secondary/20 flex items-center justify-center">
                <span className="text-secondary font-bold text-lg sm:text-xl">RPE</span>
              </div>
            </div>
          </div>

          <div className="bg-primary p-6 sm:p-8 lg:p-10 rounded-2xl sm:rounded-3xl text-left flex flex-col justify-between text-on-primary min-h-[220px] sm:min-h-0">
            <span className="material-symbols-outlined text-4xl sm:text-5xl">vibration</span>
            <div>
              <h3 className="text-xl sm:text-2xl font-headline font-bold mb-2">Rest Cues</h3>
              <p className="text-on-primary/80 text-sm sm:text-base">
                Subtle reminders help you stay in rhythm without staring at the screen.
              </p>
            </div>
          </div>

          <div className="bg-surface-container p-6 sm:p-8 lg:p-10 rounded-2xl sm:rounded-3xl text-left border border-outline-variant/20">
            <span className="material-symbols-outlined text-secondary text-3xl sm:text-4xl mb-4 sm:mb-6">
              history
            </span>
            <h3 className="text-lg sm:text-xl font-headline font-bold mb-2">Instant History</h3>
            <p className="text-on-surface-variant text-sm">
              Compare today&apos;s lifts against recent work while the set is still fresh.
            </p>
          </div>

          <div className="md:col-span-2 bg-surface-container-highest p-6 sm:p-8 lg:p-10 rounded-2xl sm:rounded-3xl text-left border border-outline-variant/10 flex flex-col sm:flex-row items-start sm:items-center gap-6 sm:gap-8">
            <div className="p-6 sm:p-8 bg-surface-container-low rounded-2xl shrink-0 self-center sm:self-auto">
              <span className="material-symbols-outlined text-5xl sm:text-6xl text-primary">
                monitoring
              </span>
            </div>
            <div className="text-left">
              <h3 className="text-xl sm:text-2xl font-headline font-bold mb-2">Progress Context</h3>
              <p className="text-on-surface-variant text-sm sm:text-base">
                Understand session volume and training balance without turning your workout into a
                spreadsheet.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
